import { useTenantConfig } from 'utils/hooks/useTenantConfig';
import { InitialMultiEngagementSettings } from './MultiEngagement.types.js';

export const useMultiEngagementSelector = (): InitialMultiEngagementSettings => {
  const tenantConfig = useTenantConfig();

  return {
    maxActiveEmployeeEngagements: tenantConfig?.features?.engagement?.orderedFeatures?.find(
      (feature) => feature.name === 'max-active-employee-engagements'
    ),
    maxActiveNonEmployeeEngagements: tenantConfig?.features?.engagement?.orderedFeatures?.find(
      (feature) => feature.name === 'max-active-non-employee-engagements'
    ),
    engagement: tenantConfig?.features?.engagement
  };
};
